import Vue from 'vue';

// http请求
import './axios/api';

import utils from './assets/scripts/utils';
import docCookies from './axios/cookies';

// document.cookie
window.$docCookies = docCookies;

// set font-size
const middleSize = 768;
const minSize = 375;
const baseSize = 1920;

const setRem = () => {
    // 全局绑定 clientWidth
    const width = document.documentElement.clientWidth;
    const dpr = width <= middleSize ? window.devicePixelRatio : 1;

    let scale = width / baseSize;
    if (width > middleSize && scale > 1) {
        scale = 1;
    }

    let realFont = baseSize * scale;

    if (width / dpr < middleSize) {
        scale = width / minSize;
        realFont = 375 * scale;
    }

    const fontSize =
        (width <= middleSize ? (realFont / 10 / 37.5) * 192 : realFont / 10) +
        'px';

    document.documentElement.style.fontSize = fontSize;
};
setRem();
window.onresize = () => {
    setRem();
    if (window.vm) {
        window.vm.$store.commit('SET_CW', document.documentElement.clientWidth);
        window.vm.$store.commit('SET_CH', document.documentElement.clientHeight);
    }
};

// 全局指令
Vue.directive('load-more', {
    bind: function (el, binding) {
        el.handle = function () {
            if (utils.getScrollTop() + utils.getWindowHeight() + 200 >= utils.getScrollHeight()) {
                // console.log('bootom');
                binding.value && binding.value();
            }
        };
        window.addEventListener('scroll', el.handle);
    },
    unbind: function (el) {
        window.removeEventListener('scroll', el.handle);
    },
});

// 原型属性
Vue.prototype.$isMob = (() => {
    const ua = navigator.userAgent.toLowerCase();
    const agents = ['Android', 'iPhone', 'SymbianOS', 'Windows Phone', 'iPad', 'iPod'];
    let result = false;
    for (let i = 0; i < agents.length; i++) {
        if (ua.indexOf(agents[i].toLowerCase()) > -1) {
            result = true;
        }
    }
    return result;
})();
